import { useEffect } from "react";

/**
 * Make a printout carry what the screen tucks away. Collapsed answers and source lists
 * are <details>; the browser prints them shut, so a printed state page used to list its
 * FAQ questions without the answers and its sources as "10 sources, Show". On beforeprint
 * every closed <details> is opened, and on afterprint the ones we opened are closed again.
 */
export function PrintPrep() {
  useEffect(() => {
    const opened: HTMLDetailsElement[] = [];
    const before = () => {
      document.querySelectorAll<HTMLDetailsElement>("main details:not([open])").forEach((d) => {
        d.open = true;
        opened.push(d);
      });
    };
    const after = () => {
      for (const d of opened.splice(0)) d.open = false;
    };
    window.addEventListener("beforeprint", before);
    window.addEventListener("afterprint", after);
    return () => {
      window.removeEventListener("beforeprint", before);
      window.removeEventListener("afterprint", after);
    };
  }, []);
  return null;
}
